import React from "react";
import { useNavigate } from "react-router-dom";

const Error = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      justifyContent: "center",
      alignItems: "center",
    }}>
      Error, please
      <br />
      <button onClick={() => navigate(-1)}>go back to previous page</button>
    </div>
  );
};

export default Error;
